import { useEffect, useState } from "react";
import { resetCases } from '../services/casesService';
import { resetServices } from '../services/servicesService';
import { logout, getCurrentUser, register, changePassword } from '../services/authService';
import { getCases, deleteCase } from "../services/casesService";
import { getServices,deleteService,updateServicio } from "../services/servicesService";
//import CaseForm from "../components/CaseForm";
import CaseTree from "../components/CaseTree";
import ServiceForm from "../components/ServiceForm";
import "./AdminPanel.css";
import { API_BASE_URL } from '../config/apiConfig';
export default function AdminPanel({ onLogout }) {
  const URL_NO_API = API_BASE_URL.replace('/api', '');
  const [cases, setCases] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingServiceId, setEditingServiceId] = useState(null);
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('cases-hierarchy'); // 'cases-hierarchy', 'cases-legacy', 'register', 'changePassword'
  const [registerForm, setRegisterForm] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: ''
  });
  const [changePasswordForm, setChangePasswordForm] = useState({
    current_password: '',
    password: '',
    password_confirmation: ''
  });
  const [message, setMessage] = useState('');
  const handleLogout = () => {
    logout();
    onLogout();
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await register(registerForm.name, registerForm.email, registerForm.password, registerForm.password_confirmation);
      setMessage('Usuario registrado exitosamente');
      setRegisterForm({ name: '', email: '', password: '', password_confirmation: '' });
    } catch (error) {
      setMessage(error.message);
    }
  };
  const handleResetCases = async () => {
    if (!window.confirm("¿Resetear todos los casos?")) return;
    try {
      await resetCases();
      loadCases();
      setMessage('Casos reseteados exitosamente');
    } catch (error) {
      setMessage(error.message);
    }
  };
  const handleResetServices = async () => {
    if (!window.confirm("¿Resetear todos los servicios?")) return;
    try {
      await resetServices();
      loadServices();
      setMessage('Servicios reseteados exitosamente');
    } catch (error) {
      setMessage(error.message);
    }
  };
  const handleChangePassword = async (e) => {
    e.preventDefault();
    try {
      await changePassword(changePasswordForm.current_password, changePasswordForm.password, changePasswordForm.password_confirmation);
      setMessage('Contraseña cambiada exitosamente');
      setChangePasswordForm({ current_password: '', password: '', password_confirmation: '' });
    } catch (error) {
      setMessage(error.message);
    }
  };

  const loadCases = async () => {
    try {
      setLoading(true);
      const data = await getCases();
      setCases(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setCases([]);
    } finally {
      setLoading(false);
    }
  };

  const loadServices = async () => {
    try {
      setLoading(true);
      const data = await getServices();
      setServices(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setServices([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setMessage('');
    setUser(getCurrentUser());
    loadCases();
    loadServices();
  }, []);

/*   const handleDeleteCase = async (id) => {
    if (!window.confirm("¿Eliminar este caso?")) return;

    const result = await deleteCase(id);
    if (result?.success) loadCases();
  }; */
 const handDeleteService = async (id) => {
    if (!window.confirm("¿Eliminar este servicio?")) return;

    const result = await deleteService(id);
    if (result?.success) loadServices();
  }
  useEffect(() => {
  setMessage('');
}, [activeTab]);

  return (
    <div className="admin-panel">
      {/* HEADER */}
      <div className="admin-header">
        <div>
          <h1>Panel de Administración</h1>
          <p>Gestión de casos de clientes</p>
        </div>

        <div className="admin-header-actions">
          <span className="admin-user">
            Bienvenido, {user?.name}
          </span>
          <button onClick={handleLogout} className="btn-danger">
            Cerrar Sesión
          </button>
        </div>   
      </div>

      {/* TABS */}
      <div className="admin-tabs">
        <button 
          className={`tab-button ${activeTab === 'cases-hierarchy' ? 'active' : ''}`}
          onClick={() => setActiveTab('cases-hierarchy')}
        >
          Casos Jerarquía
        </button>
{/*         <button 
          className={`tab-button ${activeTab === 'cases-legacy' ? 'active' : ''}`}
          onClick={() => setActiveTab('cases-legacy')}
        >
          Casos Legacy
        </button> */}
        <button 
          className={`tab-button ${activeTab === 'register' ? 'active' : ''}`}
          onClick={() => setActiveTab('register')}
        >
          Registrar Usuario
        </button>
        <button 
          className={`tab-button ${activeTab === 'changePassword' ? 'active' : ''}`}
          onClick={() => setActiveTab('changePassword')}
        >
          Cambiar Contraseña
        </button>
        <button 
          className={`tab-button ${activeTab === 'resetCases' ? 'active' : ''}`}
          onClick={() => setActiveTab('resetCases')}
        >
          Resetear Casos
        </button>   
        <button 
          className={`tab-button ${activeTab === 'createServices' ? 'active' : ''}`}
          onClick={() => setActiveTab('createServices')}
        >
          Crear Servicios
        </button>    
        <button 
          className={`tab-button ${activeTab === 'resetServices' ? 'active' : ''}`}
          onClick={() => setActiveTab('resetServices')}
        >
          Resetear Servicios
        </button>                      
      </div>

      {/* CONTENT */}
      <div className="admin-content">
{/*         {activeTab === 'cases-legacy' && (
          <>
            {!showForm ? (
              <>
                <div className="admin-toolbar">
                  <button
                    className="btn-add-case"
                    onClick={() => setShowForm(true)}
                  >
                    + Nuevo Caso
                  </button>

                  <div className="cases-count">
                    {loading
                      ? "Cargando..."
                      : `${cases.length} caso${cases.length !== 1 ? "s" : ""}`}
                  </div>
                </div>

                {loading && <p>Cargando casos...</p>}

                {!loading && cases.length === 0 && (
                  <p>No hay casos cargados</p>
                )}

                <div className="cases-grid">
                  {cases.map((c) => (
                    <div key={c.id} className="case-card">
                      <h3>{c.client_name}</h3>
                      <p>{c.description}</p>
                      <div className="case-media">
                        {Array.isArray(c.media) &&
                          c.media.map((m) =>
                            m.type === "image" ? (
                              <img
                                key={m.id}
                                src={`${URL_NO_API}/storage/${m.path}`}
                                alt=""
                              />
                            ) : (
                              <video
                                key={m.id}
                                src={`${URL_NO_API}/storage/${m.path}`}
                                controls
                              />
                            )
                          )}
                      </div>

                      <button
                        className="btn-delete"
                        onClick={() => handleDeleteCase(c.id)}
                      >
                        Eliminar
                      </button>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <CaseForm
                onCreated={() => {
                  loadCases();
                  setShowForm(false);
                }}
                onCancel={() => setShowForm(false)}
              />
            )}
          </>
        )} */}
        
        {activeTab === 'cases-hierarchy' && (
          <CaseTree />
        )}

        {activeTab === 'register' && (
          
          <div className="register-form">
            <h2>Registrar Nuevo Usuario</h2>
            <form onSubmit={handleRegister}>
              <div className="form-group">
                <label>Nombre:</label>
                <input
                  type="text"
                  value={registerForm.name}
                  onChange={(e) => setRegisterForm({...registerForm, name: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Email:</label>
                <input
                  type="email"
                  value={registerForm.email}
                  onChange={(e) => setRegisterForm({...registerForm, email: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Contraseña:</label>
                <input
                  type="password"
                  value={registerForm.password}
                  onChange={(e) => setRegisterForm({...registerForm, password: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Confirmar Contraseña:</label>
                <input
                  type="password"
                  value={registerForm.password_confirmation}
                  onChange={(e) => setRegisterForm({...registerForm, password_confirmation: e.target.value})}
                  required
                />
              </div>
              <button type="submit" className="btn-primary">Registrar</button>
            </form>
            {message && <p className="message">{message}</p>}
          </div>
        )}

        {activeTab === 'changePassword' && (
          <div className="change-password-form">
            <h2>Cambiar Contraseña</h2>
            <form onSubmit={handleChangePassword}>
              <div className="form-group">
                <label>Contraseña Actual:</label>
                <input
                  type="password"
                  value={changePasswordForm.current_password}
                  onChange={(e) => setChangePasswordForm({...changePasswordForm, current_password: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Nueva Contraseña:</label>
                <input
                  type="password"
                  value={changePasswordForm.password}
                  onChange={(e) => setChangePasswordForm({...changePasswordForm, password: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Confirmar Nueva Contraseña:</label>
                <input
                  type="password"
                  value={changePasswordForm.password_confirmation}
                  onChange={(e) => setChangePasswordForm({...changePasswordForm, password_confirmation: e.target.value})}
                  required
                />
              </div>
              <button type="submit" className="btn-primary">Cambiar Contraseña</button>
            </form>
            {message && <p className="message">{message}</p>}
          </div>
        )}
        {activeTab === 'resetCases' && (
          <div className="reset-cases">
            <h2>Resetear Casos a Estado Inicial</h2>
            <p>Esta acción eliminará todos los casos y los restablecerá al estado inicial. ¿Deseas continuar?</p>
            <button className="btn-danger" onClick={handleResetCases}>Resetear Casos</button>
            {message && <p className="message">{message}</p>} 
          </div>
        )}
        {activeTab === 'createServices' && (
          <div className="create-services">
            <h2>{editingServiceId ? 'Editar Servicio' : 'Crear Servicios'}</h2>
            {!showForm && (
                <button className="btn-add-case" onClick={() => {setShowForm(true); setEditingServiceId(null);}}>+ Nuevo Servicio</button>
            )}
            {showForm && (
              <ServiceForm
                id={editingServiceId}
                onCreated={() => {
                  loadServices();
                  setShowForm(false);
                  setEditingServiceId(null);
                }}
                onUpdated={() => {
                  loadServices();
                  setShowForm(false);
                  setEditingServiceId(null);
                }}
                onCancel={() => {
                  setShowForm(false);
                  setEditingServiceId(null);
                }}
              />
            )}

                  <div className="services-count">
                    {loading
                      ? "Cargando..."
                      : `${services.length} servicio${services.length !== 1 ? "s" : ""}`}
                  </div>
                

                {loading && <p>Cargando servicios...</p>}
                {!loading && services.length === 0 && (
                  <p>No hay servicios cargados</p>
                )}

                <div className="services-grid">
                  {services.map((c) => (
                    <div key={c.id} className="case-card">
                      <h3>{c.title}</h3>
                      <p>{c.description}</p>
                      <div className="case-media">

                            
                              <img
                                key={c.id}
                                src={`${URL_NO_API}/storage/${c.path_image}`}
                                alt=""
                              />
                            

                      </div>

                      <button
                        className="btn-edit"
                        onClick={() => {                          
                          setEditingServiceId(c.id);
                          setShowForm(true);
                        }}
                      >
                        Editar
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => handDeleteService(c.id)}
                      >
                        Eliminar
                      </button>
                    </div>
                  ))}
                </div>
          </div>

        )}    
        {activeTab === 'resetServices' && (
          <div className="reset-cases">
            <h2>Resetear Servicios a Estado Inicial</h2>
            <p>Esta acción eliminará todos los servicios y los restablecerá al estado inicial. ¿Deseas continuar?</p>
            <button className="btn-danger" onClick={handleResetServices}>Resetear Servicios</button>
            {message && <p className="message">{message}</p>} 
          </div>
        )}            
      </div>
    </div>
  );
}
